/**
 * 强制格式化为数字字符串
 *
 * Note: 该方法不会对数字进行四舍五入，只是简单的 toString()。并且不支持 Infinity 和 -Infinity，
 * 如果不希望排除处理 Infinity 或者 -Infinity，应当使用 bigint 类型。
 *
 * 遵循以下规则：
 * 1. 如果为 null，undefined，则返回 -
 * 2. 如果 typeof 为 bigint，则返回 bigint.toString()
 * 3. 如果 typeof 不是 number，或者 Number.isNaN 判断为真，则返回 -
 * 4. 如果是 Infinity 或者 -Infinity，则返回 -
 * 5. 其他情况，返回 n.toString()
 *
 * @param n 数字
 * @param strWhenInvalid 当 n 为 null，undefined，NaN，Infinity，-Infinity 时的返回值，默认为 -
 * @returns 数字字符串
 */
export const forceFormatNumberWith = (n?: number | bigint | null, strWhenInvalid = '-') => {
  if (!n) return strWhenInvalid
  if (typeof n === 'bigint') return n.toString()
  if (!Number.isFinite(n)) return strWhenInvalid

  return n.toString()
}
